const PHRASES = [
  "FORMULA BOTANICA",
  "SENZA SILICONI",
  "SENZA PARABENI",
  "PRODOTTO ARTIGIANALE",
  "NON TESTATO SU ANIMALI",
  "CURA DEL CUOIO CAPELLUTO",
];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES, ...PHRASES];
  return (
    <div data-testid="editorial-marquee" className="bg-white/50 border-y border-lilac-light py-5 overflow-hidden">
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((phrase, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-serif italic text-lg sm:text-xl text-plum/80 px-6 whitespace-nowrap">
                  {phrase}
                </span>
                <span className="text-lilac-dark text-xs">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
